import { EndpointCallParams } from '@core/api/endpointCallParams';
import { IApiStore } from '@core/api/apiStore';

export const performGetDeployments = async (api: IApiStore, params: EndpointCallParams<null>) =>
    api.get('xapi/integration/deployments/list', params);
